<app-vw-pb-create-label>
  <ng-template appVwPbCreateLabelForm [formGroup]="form">
    <mat-form-field
      class="tw-flex tw-w-full"
      appearance="outline"
      *ngIf="batches.length > 0"
    >
      <mat-label>Seleccionar Batch</mat-label>
      <mat-select formControlName="workOrderBatch">
        <mat-option>
          <ngx-mat-select-search
            formControlName="search"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let val of filteredBatches" [value]="val.id">
          {{ val.batchNumber }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</app-vw-pb-create-label>
